<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_6"></a><a id="contents"></a><strong>Table of Contents</strong></h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/introduction#introduction"><strong>Introduction: How to Use This Book</strong></a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01"><strong>Chapter 1: A Primer on Grilling Methods &amp; Equipment</strong></a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch02#ch02"><strong>Chapter 2: How to Build Flavor into Anything Grilled</strong></a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>Chapter 3: Beef</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>Chapter 4: Veal</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong>Chapter 5: Pork</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong>Chapter 6: Lamb</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><strong>Chapter 7: Goat, Bison &amp; Other Game Meat</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><strong>Chapter 8: Chicken &amp; Turkey</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample"><strong>Chapter 9: Duck, Goose &amp; Game Birds</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample"><strong>Chapter 10: Fish</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample"><strong>Chapter 11: Crustaceans &amp; Mollusks</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample"><strong>Chapter 12: Vegetables</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample"><strong>Chapter 13: Fruit</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample"><strong>Chapter 14: Cheese, Other Dairy Foods &amp; Eggs</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample"><strong>Chapter 15: Bread, Sandwiches, Cakes &amp; Cookies</strong></span></p>
<p class="tocback1"><span class="nounder" href="#/xhtml/app01#app01" title="Link target outside of Sample"><strong>46 Points of Ingredient Know-How</strong></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/sources#sources" title="Link target outside of Sample"><strong>Sources</strong></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><strong>Index</strong></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/equivalents#equivalents" title="Link target outside of Sample"><strong>Table of Equivalents</strong></span></p>
<p class="image"><a id="page_7"></a><img alt="image" src="images/f0007-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?094d56bc